export class SalesTypesMovimentacoes {
  constructor(instance) {
    this.instance = instance;
  }

  getMovimentacoes(produtoId, filter) {
    if (filter instanceof URLSearchParams) {
      if (!filter.has('fazenda')) {
        filter.append('fazenda', '0');
      }

      if (produtoId) {
        filter.append('produto', produtoId);
      }

      return this.instance.get(
        '/v1/cad-estoque-producao-avulsa/movimentacoes',
        {
          params: filter,
        },
      );
    }

    const filtredParams = filter ? { ...filter } : {};

    delete filtredParams.intervalo;
    delete filtredParams.page;

    if (filtredParams.dateStart) {
      filtredParams.dataInicio = filtredParams.dateStart;
      delete filtredParams.dateStart;
    }
    if (filtredParams.dateEnd) {
      filtredParams.dataFim = filtredParams.dateEnd;
      delete filtredParams.dateEnd;
    }

    if (filtredParams.clienteId) {
      filtredParams.cliente = filtredParams.clienteId;
      delete filtredParams.clienteId;
    }

    return this.instance.get('/v1/cad-estoque-producao-avulsa/movimentacoes', {
      params: {
        produto: produtoId,
        fazenda: 0,
        ...filtredParams,
      },
    });
  }
}

export default SalesTypesMovimentacoes;
